import { getAuth } from "firebase/auth";
import { Config } from "../config";
import { UserData } from "../Models/userData";

export class DataService {

    getUserURL = "https://getUser" + Config.functionUrl + "";
    saveUserURL = "https://saveUser" + Config.functionUrl + "";
    unsubscribeUserURL = "https://braintreeUnsubscribe" + Config.functionUrl + "";
    videoURL = "https://getVideoURL" + Config.functionUrl + "";;

    user: UserData | null = null;
    userConnected: boolean = false;
    userToken: any;

    constructor() {
    }





    async getUser(email: string | null, token?: string | null): Promise<UserData> {
        let rawResponse;
        if (token) {
            rawResponse = await fetch(this.getUserURL + `?e=${encodeURIComponent(email || "")}`, {
                method: "GET",
                headers: {
                    "Content-Type": "application/json",
                    "Authorization": `Bearer ${token}`
                }
            });
        }
        else {
            rawResponse = await fetch(this.getUserURL + `?e=${encodeURIComponent(email || "")}`, {
            })
        }

        let response = await rawResponse.json() as { success: boolean, userData: UserData };
        return response.userData;
    }



    async saveUser(data: UserData): Promise<void> {
        //save this.user uniquement les valeurs géré coté client (pas paid, date etc)
        await fetch(this.saveUserURL, {
            method: "POST",
            headers: {
                "Content-Type": "application/json",
            },
            body: JSON.stringify(data)
        })
        return;
    }

    async saveFile(email: string, files: FileList): Promise<void> {
        return;
    }

    async unsubscribeUser(token: string, email: string) {

        let r = await fetch(this.unsubscribeUserURL, {
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Authorization": `Bearer ${token}`
            }
        });

        let response = await r.json();
        return response;
    }

    async getVideoURL(token: string | null, video: any) {

        // envoyer le token dans l'en-tête Authorization
        let rawResponse = await fetch(this.videoURL + `?v=${video}`, {
            method: "GET",
            headers: {
                "Content-Type": "application/json",
                "Authorization": `Bearer ${token}`
            }
        });
        let response = await rawResponse.json();
        return response.url;

    }

    async changePassword(password: string) {

    }

}
